var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.connectDevice}},[_vm._v("连接蓝牙设备")])])
}
var staticRenderFns = []

export { render, staticRenderFns }